/**
 * Difficulty Classes by Level (Foundry: src/module/dc.ts, from Player Core's table), used by
 * inline checks whose DC is `@self.level` and by anything else that wants a level-based DC.
 */

const DC_BY_LEVEL: readonly number[] = [14, 15, 16, 18, 19, 20, 22, 23, 24, 26, 27, 28, 30, 31, 32, 34, 35, 36, 38, 39, 40, 42, 44, 46, 48, 50];

export interface LevelDCOptions {
  /** Proficiency Without Level: the Level is left out of every DC (GM Core). */
  proficiencyWithoutLevel?: boolean;
}

/** The DC for a task of the given Level; -1 gives 13 as Foundry does. */
export function levelBasedDC(level: number, options: LevelDCOptions = {}): number {
  const clamped = Math.max(-1, Math.min(25, Math.trunc(level)));
  const dc = clamped === -1 ? 13 : DC_BY_LEVEL[clamped]!;
  return options.proficiencyWithoutLevel ? dc - Math.max(0, clamped) : dc;
}
